import { toast } from "react-toastify";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../../config/api";

function blobUrlToFile(blobUrl, filename) {
    return fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => new File([blob], filename, { type: blob.type }));
}


export const getChatList = createAsyncThunk('chat/list', async (page, { getState, dispatch }) => {
    try {
        const state = getState()
        const { userData } = state.user
        const req = await apiInstance.get(`/api/chat/conversations?page=${page}`);
        const res = req.data;

        if (res.status === 'success') {
            const convos = res.conversations
            if (convos && convos.length > 0) {
                convos.forEach(list => {
                    const { room, user } = list
                    // console.log('each room ; ', room)
                    dispatch(getChatMessageHistory({ userId: user.userId, conversationId: room }))
                });
            }
            return { conversations: res.conversations, userId: userData.userId }
        } else {
            throw new Error(res.message)
        }
    }
    catch (error) {
        console.log('error fetching chat list ; ', error.message)
        throw new Error(error.message)
    }
})

export const getChatMessageHistory = createAsyncThunk('chat/message/history', async ({ userId, conversationId, lastEvaluatedKey }, { getState }) => {
    try {
        const state = getState()
        const { userData } = state.user
        const req = await apiInstance.get(`/api/chat/history/${conversationId}?lastEvaluatedKey=${encodeURIComponent(lastEvaluatedKey)}`);
        const res = req.data;
        // console.log('chat history; ', res)
        if (res.status === 'success') {
            return { messages: res.allMessages.messages, userId, myId: userData.userId, lastEvaluatedKey: res.allMessages.lastEvaluatedKey, status: 'success' }
        } else {
            throw new Error(res.message)
        }
    }
    catch (error) {
        console.log('error fetching chat messages ; ', error.message)
        throw new Error(error.message)
    }
})

export const updateMediaProgress = createAction('chat/media/updateProgress', ({ fakeId, progress, roomId }) => ({
    payload: { fakeId, progress, roomId }
}))

export const uploadChatMedia = createAsyncThunk('chat/media/upload', async ({ media, mediaName, receiverId, roomId, fakeId, socketId }) => {
    try {
        console.log('uploading chat media...', media)
        const formData = new FormData();

        const processedImage = await blobUrlToFile(media, mediaName || `chatMedia.png`);
        // console.log('images ', processedImage)

        formData.append('files', processedImage, processedImage.name)

        formData.append('receiverId', receiverId)
        formData.append('socketId', socketId)

        const request = await apiInstance.post("/api/chat/media/upload", formData);
        const response = request.data;


        if (response.status === 'success') {
            const payload = {
                messageId: response.messageId,
                mediaUrl: response.fileInfo.postUrl,
                roomId,
                fakeId,
                createdAt: response.createdAt,
                conversationId: response.conversationId,
                fileType: response.fileInfo.fileType
            };
            // console.log('Upload success:', payload);
            return payload
        } else {
            throw new Error(response.message)
        }

    } catch (error) {
        console.log('chat media error ; ', error.message)
        throw new Error(error.message)
    }
}
);

export const uploadChatVoiceNote = createAsyncThunk('chat/voice-note/upload', async ({ media, receiverId, roomId, fakeId, socketId }) => {
    try {
        const formData = new FormData();

        const processedImage = await blobUrlToFile(media, "bd-chat-voice-record");

        formData.append('files', processedImage, processedImage.name);
        formData.append('receiverId', receiverId);
        formData.append('socketId', socketId);

        const request = await apiInstance.post("/api/chat/media/upload", formData);
        const response = request.data;

        if (response.status === 'success') {
            const payload = {
                messageId: response.messageId,
                mediaUrl: response.fileInfo.postUrl,
                roomId,
                fakeId,
                createdAt: response.createdAt,
                conversationId: response.conversationId,
                fileType: response.fileInfo.fileType
            };
            // console.log('Upload success:', payload);
            return payload
        } else {
            throw new Error(response.message)
        }

    } catch (error) {
        console.log('chat media error ; ', error.message)
        throw new Error(error.message)
    }
}
);

export const getChatMedia = createAsyncThunk('chat/medias', async ({ conversationId, roomId }) => {
    try {
        const req = await apiInstance.get(`/api/chat/media/${conversationId}`);
        const res = req.data;
        // console.log('chat media; ', res)
        if (res.message === "Media files retrieved successfully") {
            const payload = {
                roomId: roomId,
                medias: res.media
            }
            return payload
        } else if (res.message === "No media files found.") {
            const payload = {
                roomId: roomId,
                medias: []
            }
            return payload
        }
        else {
            throw new Error(res.message)
        }
    }
    catch (error) {
        console.log('error fetching chat medias ; ', error.message)
        throw new Error(error.message)
    }
})

export const forwardChatMedia = createAsyncThunk('chat/media/forward', async ({ messageId, receiverId, roomId, fileType, socketId, tempId }, { dispatch }) => {
    try {
        const payload = {
            messageId,
            receiverId,
            socketId
        }
        const request = await apiInstance.post("/api/chat/media/forward", payload);
        const response = request.data;
        console.log('forward media response; ', response)
        if (response.status === 'success') {
            const { messageId, mediaUrl, conversationId, createdAt } = response
            return { messageId, tempId, mediaUrl, fileType, roomId, conversationId, createdAt }
        }
    } catch (error) {
        console.log('error forwarding media ; ', error.message)
        throw new Error(error.message)
    }
});

export const deleteMediaChat = createAsyncThunk('chat/media/delete', async ({ messageId, conversationId, receiverId, roomId, socketId }) => {
    const loading = toast.loading('deleting message...', { position: 'bottom-center', autoClose: false })

    const controller = new AbortController(); // Create an AbortController instance
    const signal = controller.signal;

    try {
        const timeoutId = setTimeout(() => controller.abort(), 15000);
        const request = await apiInstance.post("/api/chat/media/single", { messageId, conversationId, receiverId, socketId }, { signal });
        const response = request.data;
        clearTimeout(timeoutId)
        // console.log('deleted media; ', response)
        if (response.status === 'success') {
            toast.dismiss(loading)
            return { messageId, roomId }
        } else {
            toast.dismiss(loading)
            toast.error('Unable to delete message try again later.', { position: 'bottom-center' })
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('error deleting media ;', error.message)
        toast.dismiss(loading)
        toast.error('Unable to delete media. Please try again later.')
        throw new Error(error.message)
    }
})

export const uploadChatDoc = createAsyncThunk('chat/doc/upload', async ({ media, mediaName, receiverId, mimeType, roomId, fakeId, socketId }, { dispatch }) => {

    try {
        const formData = new FormData();

        const processedImage = await blobUrlToFile(media, mediaName || `chatDocument`);
        formData.append('receiverId', receiverId);
        formData.append('mimeType', mimeType);

        formData.append('files', processedImage, processedImage.name);
        formData.append('socketId', socketId);

        const request = await apiInstance.post("/api/chat/media/upload/docs", formData);
        const response = request.data;
        if (response.status === 'success') {
            const payload = {
                messageId: response.messageId,
                mediaUrl: response.fileInfo.postUrl,
                roomId,
                fakeId,
                createdAt: response.createdAt,
                conversationId: response.conversationId,
                fileType: response.fileInfo.fileType,
                imageName: response.fileInfo.imageName
            };
            // console.log('Upload success:', payload);
            return payload
        } else {
            throw new Error(response.message)
        }
    } catch (error) {
        console.log('chat media error ; ', error.message)
        throw new Error(error.message)
    }
}
);

export const searchConversations = createAsyncThunk('chat/searchConversations', async (searchQuerry, thunkAPI) => {
    try {
        // Make the request
        const response = await apiInstance.get(`/api/chat/search/conversations?searchQuery=${searchQuerry}}`);
        const data = response.data;
        // console.log('convo search: ', data)
        // Check if the status is success
        if (data.status === 'success') {
            return data.conversations; // Return the conversations
        } else {
            // Handle API errors (e.g., 400 or 500 status)
            return thunkAPI.rejectWithValue(data.message || 'Something went wrong');
        }
    } catch (error) {
        // Handle general errors
        return thunkAPI.rejectWithValue(error.message);
    }
}
);

export const archiveConversation = createAsyncThunk('chat/archiveConversation', async ({ conversationId, chat }, { rejectWithValue }) => {
    try {
        // console.log('roomId; ', conversationId)
        const response = await apiInstance.post(`/api/chat/conversations/${conversationId}/archive`);
        const data = response.data;

        // console.log('archive res: ', data)
        if (data.status === "success") {
            return { data, chatItem: chat }; // Return success response
        } else {
            return rejectWithValue(data.message); // Return error message
        }
    } catch (error) {
        console.log('archive error; ', error.message)
        return rejectWithValue(error.message); // Handle general errors
    }
}
);

export const unarchiveConversation = createAsyncThunk('chat/unarchiveConversation', async (conversationId, { rejectWithValue }) => {
    try {
        const response = await apiInstance.post(`/api/chat/unarchive/${conversationId}`)
        const data = response.data;
        // console.log('unarchive res: ', data)
        if (data.status === 'success') {
            return { roomId: conversationId }; // Return success response
        } else {
            return rejectWithValue(data.message); // Return error message
        }
    } catch (error) {
        console.log('unarchive error; ', error.message)
        return rejectWithValue(error.message); // Handle general errors
    }
}
);

export const clearChat = createAsyncThunk('chat/delete-conversation', async ({ conversationId, roomId }) => {
    try {
        const req = await apiInstance.delete(`/api/chat/conversations/${conversationId}`)
        const res = req.data;

        if (res.status === 'success') {
            return { roomId, conversationId }
        } else {
            throw new Error(res.message)
        }
    } catch (error) {
        console.log('error deleting chat ; ', error.message)
        throw new Error(error.message)
    }
})